import { createTheme } from '@mui/material/styles';

const vadoThemeMui5 = createTheme({
    palette: {
        primary: {
            light: '#dae6de',
            main: '#b1cdbb',
        },
        secondary: {
            main: '#599670',
        },
        warning: {
            main: '#CF8A7B',
        },
        success: {
            main: '#28a745',
            light: '#e6f4ea',
        },
    },
    typography: {
        // useNextVariants is not needed in MUI v5
    },
    components: {
        // MUI v5 changed TextField default variant from 'standard' to 'outlined' — restore original behaviour
        MuiTextField: {
            defaultProps: {
                variant: 'standard',
            },
        },
        MuiFormControl: {
            defaultProps: {
                variant: 'standard',
            },
        },
    },
});

export default vadoThemeMui5;
